const occupationDict = {
    'Business Owner': [
        'Accommodation and Food Services',
        'Administrative and Support Services',
        'Arms or Weapons Manufacture or Distribution',
        'Arts and Recreation Services',
        'Bar or Licensed Club',
        'Betting, Bookmaking, Gambling and Gaming',
        'Cafe and Restaurant',
        'Charity Community or Social Services',
        'Construction',
        'Digital Currency Traders',
        'Education and Training',
        'Electricity, Gas, Water and Waste Services',
        'Farming and Agriculture',
        'Financial and Insurance Services',
        'Health Care and Social Assistance',
        'Hotel and Motel',
        'Information Media and Telecommunications',
        'Jewel, Gem and Precious Metals',
        'Mining, Gas, Oil and Petroleum',
        'Money Exchange or Foreign FX Services',
        'Pawn Brokers',
        'Professional, Scientific and Technical Services',
        'Public Administration and Safety',
        'Real Estate Agent',
        'Rental, Hiring and Real Estate Services',
        'Retail Trade',
        'Transport, Postal and Warehousing',
        'Wholesale Trade',
    ],
    'Chief Executives, General Managers and Legislators': [
        'Accommodation and Food Services',
        'Administrative and Support Services',
        'Arms or Weapons Manufacture or Distribution',
        'Arts and Recreation Services',
        'Bar or Licensed Club',
        'Betting, Bookmaking, Gambling and Gaming',
        'Cafe and Restaurant',
        'Charity Community or Social Services',
        'Construction',
        'Digital Currency Traders',
        'Education and Training',
        'Electricity, Gas, Water and Waste Services',
        'Farming and Agriculture',
        'Financial and Insurance Services',
        'Health Care and Social Assistance',
        'Hotel and Motel',
        'Information Media and Telecommunications',
        'Jewel, Gem and Precious Metals',
        'Mining, Gas, Oil and Petroleum',
        'Money Exchange or Foreign FX Services',
        'Pawn Brokers',
        'Professional, Scientific and Technical Services',
        'Public Administration and Safety',
        'Real Estate Agent',
        'Rental, Hiring and Real Estate Services',
        'Retail Trade',
        'Transport, Postal and Warehousing',
        'Wholesale Trade',
    ],
    'Clerical and administrative workers': [
        'Clerical and Administrative Workers',
        'Clerical and Office Support Workers',
        'General Clerical Workers',
        'Inquiry Clerks and Receptionists',
        'Numerical Clerks',
        'Office Managers and Program Administrators',
        'Personal Assistants and Secretaries',
    ],
    'Community and personal service workers': [
        'Carers and Aides',
        'Health and Welfare Support Workers',
        'Hospitality Workers',
        'Protective Service Workers',
        'Sports and Personal Service Workers',
    ],
    'Employees': [
        'Advertising, Public Relations and Sales',
        'Construction, Distribution and Production',
        'Education, Health and Welfare Services',
        'Farmers and Farm',
        'Hospitality, Retail and Service',
        'Information & Communication Technology',
    ],
    'Homemaker': [
        'Home Duties',
    ],
    'Labourers': [
        'Cleaners and Laundry Workers',
        'Construction and Mining Labourers',
        'Factory Process Workers',
        'Farm, Forestry and Garden Workers',
        'Food Preparation Assistants',
        'Labourers',
    ],
    'Machinery operators and drivers': [
        'Machine and Stationary Plant Operators',
        'Mobile Plant Operators',
        'Road and Rail Drivers',
        'Storepersons',
    ],
    'Military': [
        'Military (enlisted)',
        'Military (officer)',
    ],
    'Professionals': [
        'Accountants, Auditors and Company Secretaries',
        'Arts and Media Professionals',
        'Aviation',
        'Business, Human Resource and Marketing Professionals',
        'Design, Engineering, Science and Transport Professionals',
        'Doctor, Veterinarian, Health Professionals',
        'Education Professionals',
        'Financial Brokers and Dealers, and Investment Advisers',
        'Information & Communication Technology Professionals',
        'Legal, Social and Welfare Professionals',
        'Real Estate Agent',
    ],
    'Retired': [
        'Retired',
    ],
    'Sales workers': [
        'Sales Assistants and Salespersons',
        'Sales Representatives and Agents',
        'Sales Support Workers',
    ],
    'Student': [
        'Student',
    ],
    'Technicians and trades workers': [
        'Automotive and Engineering Trades Workers',
        'Construction Trades Workers',
        'Electrotechnology and Telecommunications Trades Workers',
        'Engineering and Science Technicians',
        'Food Trades Workers',
        'Information & Communication Technology Technicians',
        'Other Technicians and Trades Workers',
        'Skilled Animal and Horticultural Workers',
    ],
}

export const getOccupations = () => {
    return Object.keys(occupationDict)
}

export const getOccupationSubTypes = (type) => {
    return occupationDict[type]
}


// WEBPACK FOOTER //
// ./src/components/FundAdd/occupations.js